import styled from 'styled-components';

export default styled.div.attrs({ className: 'section-container background-grey-c100' })``;
